module.exports = ".menu-line {\n    padding: 10px;\n    font-weight: bold;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/context-menu/context-menu.component.css
// module id = ./src/app/components/context-menu/context-menu.component.css
// module chunks = main